import type { BuilderItemType, DraftNode } from "../types";
import { generateLinkId } from "./link-id";

export function createDefaultItem(type: BuilderItemType): DraftNode {
  const clientId = generateLinkId();
  if (type === "Section") return { clientId, kind: "Section", label: "New section", items: [] };
  if (type === "RepeatingGroup")
    return { clientId, kind: "RepeatingGroup", label: "New repeating group", minOccurrences: 0, items: [] };
  if (type === "Display") return { clientId, kind: "Display", text: "Display text" };
  const value =
    type === "Choice"
      ? {
          kind: "Choice" as const,
          options: [
            { clientId: generateLinkId(), label: "Option 1" },
            { clientId: generateLinkId(), label: "Option 2" },
          ],
          cardinality: "Single" as const,
          allowFreeText: false,
        }
      : { kind: type };
  return { clientId, kind: "Question", label: "New question", required: false, value } as DraftNode;
}
